<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <span style="margin-top: 5px">{{ title }}</span>
        <v-fade-transition>
          <span style="display: inline-flex" v-if="open">
            <v-divider class="mx-2" vertical/>
            <v-btn @click.native.stop="click_add" color="primary" small>ADD</v-btn>
          </span>
        </v-fade-transition>
        <v-spacer/>
        <v-fade-transition>
          <span style="display: inline-flex" v-if="open">
            <v-divider class="mx-1" vertical/>
          </span>
        </v-fade-transition>
      </v-row>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <r-product-table
          ref="table"
          :items="items"
          :kinds="kinds"
          :toolbar="false"
          @update:items="$emit('update:items', $event)"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import VueTypes from "vue-types";
import { ProductGroupKind } from "@/modules/redactor/models/product/ProductGroupKind";
import { ProductModel } from "@/modules/redactor/models/product/ProductModel";
import RProductTable from "@/modules/redactor/views/product/r-product-table";

export default {
  name: "r-product-panel",
  components: { RProductTable },
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(ProductModel),
    kinds: VueTypes.arrayOf(ProductGroupKind),
  },
  methods: {
    click_add() {
      this.$refs.table.row_create();
    }
  }
};
</script>